import { Button, FoldPanel, showToast, Specimens, Toast } from '@src/components';

export function ToastSection() {
  return (
    <FoldPanel
      id="toasts"
      title="Toasts"
      hint="A flash from the top of the viewport. It holds for a couple of seconds, then slides away. One at a time."
      example={`showToast('Please accept the terms first');`}
    >
      <Specimens
        label="Error"
        note="The chip itself. ToastHost parks a live one at the top of the window."
      >
        <Toast>Please accept the terms first</Toast>
      </Specimens>
      <Specimens label="Live" note="Pushes a real toast through the host.">
        <Button
          variant="secondary"
          size="small"
          onClick={() => showToast('Please accept the terms first')}
        >
          Show toast
        </Button>
      </Specimens>
    </FoldPanel>
  );
}
